import React from "react";

export default class extends React.Component {
  static defaultProps = {
    reserve: "0",
    value: 1
  };

  render() {
    return (
      <span style={{ position: "relative" }}>
        <span style={{ opacity: 0 }}>{this.props.reserve}</span>
        <span
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            textAlign: "center"
          }}
        >
          {this.props.value}
        </span>
      </span>
    );
  }
}
